export default "__VITE_ASSET__B65_yIvW__"